import { WebContainer } from '@webcontainer/api';

let webcontainerInstance = null;

export async function getWebContainer() {
  if (webcontainerInstance) return webcontainerInstance;
  
  webcontainerInstance = await WebContainer.boot();
  return webcontainerInstance;
}

export async function mountFiles(files) {
  const wc = await getWebContainer();
  await wc.mount(files);
  return wc;
}

export async function startDevServer(wc, onServerReady) {
  // Install dependencies
  const installProcess = await wc.spawn('npm', ['install']);
  installProcess.output.pipeTo(new WritableStream({
    write(data) {
      console.log('WC [install]:', data);
    }
  }));
  
  const installExitCode = await installProcess.exit;
  if (installExitCode !== 0) {
    throw new Error('Installation failed');
  }

  // Start dev server
  const devProcess = await wc.spawn('npm', ['run', 'dev']);
  devProcess.output.pipeTo(new WritableStream({
    write(data) {
      console.log('WC [dev]:', data);
    }
  }));

  wc.on('server-ready', (port, url) => {
    onServerReady(url);
  });
}
